import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';
import TicketDetails from '../TicketDetails/TicketDetails';
import {ETicketPage} from '../eTicketPage.type';
import CoverContent from '../CoverContent/CoverContent';
import TransactionCard from '../TransactionCard/TransactionCard';
import EntranceTicketStatus from '../EntranceTicketStatus/EntranceTicketStatus';
import TicketScanStatus from '../TicketScanStatus/TicketScanStatus';
import TransactionTop from '../TransactionCard/TransactionTop/TransactionTop';
import EndingContent from '../EndingContent/EndingContent';
import BrandHeader from '../BrandHeader/BrandHeader';

export function useETicketPages() {
    const data = useSelector((s: RootState) => s.eTicket.data);

    const tickets = data?.tickets ?? [];
    const event = data?.event;
    const order = data?.order;

    const pages = useMemo((): ETicketPage[] => [
        {key: 'entrance', withLink: false, TopComp: EntranceTicketStatus, Comp: CoverContent},
        ...tickets.map((ticket, index) => ({
            // qid, not tid — an order can hold several tickets of the same tid
            // (e.g. two seats of one price type) and keys must stay unique
            key: `ticket-${ticket.qid}`,
            withLink: false,
            ...(event ? {
                TopComp: ticket.canceled ? undefined : TicketScanStatus,
                topProps: {ticket},
                Comp: TicketDetails,
                props: {
                    ticket,
                    index,
                    total: tickets.length,
                    event,
                    order,
                },
            } : {}),
        })),
        {key: 'transaction', withLink: true, TopComp: TransactionTop, Comp: TransactionCard},
        {key: 'ending', withLink: false, hasFooter: false, TopComp: BrandHeader, Comp: EndingContent},
    ], [tickets, event, order]);

    return {pages};
}
